import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import {
  FormArray,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { Table, TableModule } from "primeng/table";
import { v4 as uuidv4 } from "uuid";
import { InvoiceEmail } from "../../../../core/models/orders/invoicedEmail";
import { DialogModule } from "primeng/dialog";
import { CommonModule } from "@angular/common";
import { CheckboxModule } from "primeng/checkbox";
import { SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { QuotesInvoiceEmail } from "../../../../core/models/qoutes/quotesInvoiceEmail";

@Component({
  selector: "jni-summary-invoice-emails",
  templateUrl: "./summary-invoice-emails.component.html",
  styleUrls: ["./summary-invoice-emails.component.scss"],
  imports: [
    DialogModule,
    CommonModule,
    ReactiveFormsModule,
    TableModule,
    FormsModule,
    SelectModule,
    CheckboxModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class SummaryInvoiceEmailsComponent {
  @Input() invoiceListing!: QuotesInvoiceEmail[];
  @Input() selectedInvoiceListing!: InvoiceEmail[];
  @Input() parent!: FormGroup;
  @Input() addAndRemoveButtons = true;
  @Input() displayEmailInvoiceModal = false;
  @Output() newLine = new EventEmitter<boolean>();
  @Output() removeEmail = new EventEmitter<FormGroup[]>();
  @Output() closeInvoiceEmailModel = new EventEmitter();
  @Output() saveInvoiceEmailModel = new EventEmitter<QuotesInvoiceEmail[]>();
  @Output() removeInvoiceEmailModel = new EventEmitter<InvoiceEmail[]>();
  type = [
    {
      id: 1,
      name: "Business",
    },
    {
      id: 2,
      name: "Invoice",
    },
    {
      id: 3,
      name: "Payable",
    },
    {
      id: 4,
      name: "Delivery",
    },
    {
      id: 5,
      name: "Other",
    },
    {
      id: 6,
      name: "Buyer",
    },
  ];

  @ViewChild("dt") table!: Table;

  emailSelected!: FormGroup[];

  get invoicedEmails() {
    return (this.parent.get("invoicedEmail") as FormArray).controls;
  }

  onRemoveEmail() {
    if (this.emailSelected) {
      this.removeEmail.emit(this.emailSelected);
      this.emailSelected = [];
    }
  }

  closeModel() {
    this.closeInvoiceEmailModel.emit();
  }

  saveModel() {
    this.saveInvoiceEmailModel.emit(this.invoiceListing);
  }

  onEditRow(invoiceEmail: InvoiceEmail) {
    this.cancelAllEditRow();
    const row = this.table.value.filter(
      x => x.portalKey === invoiceEmail.portalKey
    );
    if (row.length > 0) {
      this.table.initRowEdit(row[0]);
    }
  }

  cancelAllEditRow() {
    this.table.value.forEach(x => {
      this.table.cancelRowEdit(x);
    });
  }

  count = 0;
  onAddNewLine() {
    this.cancelAllEditRow();
    this.count++;
    const object: InvoiceEmail = {
      id: this.count,
      email: "",
      name: "",
      purpose: "",
      save: false,
      exist: false,
      confirmation: false,
      invoice: true,
      salesOrderIdD365: "",
      invoiceEmailRecIdD365: 0,
      portalKey: uuidv4(),
      modifiedDateTime1: "",
      statusD365: "",
      messageD365: "",
      statusCodeD365: null,
      createdDate: "",
      createdBy: "",
      lastModifiedDate: null,
      lastModifiedBy: null,
      isActive: false,
    };
    this.invoiceListing.push(object);
    this.table.initRowEdit(this.table.value[this.table.value?.length - 1]);
  }

  // cancelRow(id: any) {
  //   this.invoiceListing.forEach((item, index) => {
  //     if (item.id === id) this.invoiceListing.splice(index, 1);
  //   });
  // }

  removeLine() {
    if (this.selectedInvoiceListing) {
      let rowSelected: InvoiceEmail[] = [];
      rowSelected.push(...this.selectedInvoiceListing);
      this.removeInvoiceEmailModel.emit(rowSelected);
      this.selectedInvoiceListing = [] as InvoiceEmail[];
      rowSelected = [];
    }
  }

  get showRemoveButton(): boolean {
    return this.invoiceListing.length > 1;
  }
}
